import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';

declare const $;
@Component({
  selector: 'app-statement',
  templateUrl: './statement.component.html',
  styleUrls: ['./statement.component.css']
})
export class StatementComponent implements OnInit {

  constructor(private service:AppService,private router:Router) { 
    var chkLogin=this.service.isLoggedIn();
    if(!chkLogin){
      this.router.navigateByUrl("/prepaid-recharge");
    }
  } 

  balance:string='0.00';
  txnList:any=[];
  rchTxnLmt:any=0;
  rchTxnLoader:boolean=false;

  paymentref_no=new FormControl('',Validators.required);

  ngOnInit() {
    this.getBalance();
    this.getUtilityBalance();
    this.getAllRchTxn();
    this.getAllUtilTxn();
  }
 
  getBalance(){
    this.service.post('/getUserBalance',{"key":this.service.getAuthorizationToken()}).subscribe(data => { 
      if(data[0].error==0){
          this.balance=data[0].balance;
        }
      },
      error =>{
        alert(error.errorDesc); 
        console.log(error); 
      }
    );
  }
 
  utility_balance:string='0.00';

  getUtilityBalance(){
    this.service.post('/getUtilityBalance',{"key":this.service.getAuthorizationToken()}).subscribe(data => { 
      if(data[0].error==0){
          this.utility_balance=data[0].balance;
        }
      },
      error =>{
        alert(error.errorDesc); 
        console.log(error); 
      }
    );
  }

  getAllRchTxn() {
    this.rchTxnLoader=true; 
    this.service.post('/getTransactionHistory',{key:this.service.getAuthorizationToken(),"limit":"10","offset":this.rchTxnLmt}).subscribe(data => {
        if(data[0].error=='0')
        {
            this.txnList=this.txnList.concat(data[0].result);
            this.rchTxnLmt=parseFloat(this.rchTxnLmt)+10;   
        } 
        this.rchTxnLoader=false;
      },
      error =>{
        console.log(error);  
        this.rchTxnLoader=false;
      }
    );
  }

  utilTxn:any=[];
  utilTxnLmt:any=0;

  getAllUtilTxn() {
    this.rchTxnLoader=true; 
    this.service.post('/getAllUtilTxn',{key:this.service.getAuthorizationToken(),"limit":"10","offset":this.utilTxnLmt}).subscribe(data => {
        if(data[0].error=='0')
        {
            this.utilTxn=this.utilTxn.concat(data[0].result);
            this.utilTxnLmt=parseFloat(this.utilTxnLmt)+10;   
        } 
        this.rchTxnLoader=false;
      },
      error =>{
        console.log(error);  
        this.rchTxnLoader=false;
      }
    );
  }

  updateUtilityId:any;
  openUtiRefModal(id:number){
    this.updateUtilityId=id;
    $('#utilityModalRef').modal('toggle');
  }

  updateBillLoader:boolean=false;
  updatePayment(){
    if(this.paymentref_no.invalid){
      alert('Some error found.please check once again');
    }else{
      this.updateBillLoader=true;
      this.service.post('/addBillPaymentDetail',{"utilitybill_id":this.updateUtilityId,"refno":this.paymentref_no.value}).subscribe(
        data=>{
          if(data[0].error==0){
            this.paymentref_no.reset();
            this.updateUtilityId="";
            location.reload();
            $('#utilityModalRef').modal('toggle');
          }
          alert(data[0].msg);
          this.updateBillLoader=false;
        },
        error=>{
          alert(error.errorDesc);
          this.updateBillLoader=false;
        }
      )
    }
  }
}
